export const DefaultDark = () => ({
	backgroundDefault: '#2B2C30',
	backgroundPrimary: '#3E3F44',
	backgroundPrimary60: '#36373C',
	backgroundSecondary: '#25262A',
});
